/**
 * Logo Row Slider — powered by Glide.js
 *
 *   - 5 logos visible on desktop, 2 on tablet/mobile.
 *   - Prev/Next arrows scroll one slide at a time.
 *   - Continuous infinite loop via Glide's "carousel" type (seamless wrap,
 *     so the first logo slides in from the right after the last).
 *   - Nav is hidden entirely when logos count ≤ slides-per-view for the
 *     current breakpoint (nothing to scroll through).
 */

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll("[data-logo-slider]");
  if (!sliders.length || typeof Glide === "undefined") return;

  sliders.forEach((slider) => {
    const count = parseInt(slider.dataset.logoCount || "0", 10);
    const nav = slider.querySelector(".logo-row__nav");

    // Determine slides per view for the current breakpoint (nav visibility only)
    const getPerView = () => {
      return window.innerWidth > 1024 ? 5 : 2;
    };

    const updateNavVisibility = () => {
      if (!nav) return;
      if (count <= getPerView()) {
        nav.setAttribute("hidden", "");
      } else {
        nav.removeAttribute("hidden");
      }
    };

    updateNavVisibility();

    const glide = new Glide(slider, {
      type: "carousel", // seamless infinite loop
      perView: 5,
      gap: 50,
      autoplay: false,
      hoverpause: false,
      breakpoints: {
        1024: {
          perView: 2,
          gap: 30,
        },
        640: {
          perView: 2,
          gap: 20,
        },
      },
    });

    glide.mount();

    let rt;
    window.addEventListener("resize", () => {
      clearTimeout(rt);
      rt = setTimeout(updateNavVisibility, 120);
    });
  });
});
